import ApiHelper from "./ApiHelper";

class MemberServices {
    static async revokeAccess(id) {
        return ApiHelper.getAuthenticated(`/members/access/${id}`);
    }

    static async getCompanyById(id) {
        return ApiHelper.getAuthenticated(`enterprise/info/${id}`);
    }

    static async getMemberById(id) {
        return ApiHelper.getAuthenticated(`members/${id}`);
    }

    static async getJobById(id) {
        return ApiHelper.getAuthenticated(`job/667d2a5835fa0bd00e064c77`);
    }
}
export default MemberServices;
